/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

import {
  CustomerOfferBindingDefinitionDto,
  CustomerOfferDto,
  CustomerOfferStatus,
  NoteId,
  NoteInput,
  PaginatedCustomerOfferDto,
  PrepareCustomerOfferSendResult,
  SendCustomerOfferRequest,
  SetCustomerOfferChapterCommercialOptionsRequest,
  SetCustomerOfferCoefficientRequest,
  UpdateDraftCustomerOfferRequest,
} from "../__ignore/schemas";

/**
 * Full DTOs with permitted evaluation. Independent filters combine by AND; statuses matches any selected status, intersecting status when both are supplied. Omitted status and statuses impose no status restriction. Literal case-insensitive q searches the canonical displayed name; surrounding whitespace is trimmed and blank q imposes no restriction. Wildcards and regular-expression syntax have no special meaning. latestOnly selects the highest committed version visible in the projection for each expedientId and offerOrdinal before all visible filters, including version, and before counting or pagination. A nonmatching or OBSOLETE head never causes fallback to an older revision. Default listing retains every revision. Projection visibility is eventual, not write authorization or proof of successor absence. Sort defaults name ascending with UUID ascending tie-break; version descending browses one chain's history. Trusted LIVE commercial calculation may use protected inputs; available selling remains visible while private fields and coefficient values follow their independent disclosure rules.
 * @summary List Offer revisions
 */
export const listCustomerOffersQueryPageDefault = 1;

export const listCustomerOffersQueryPerPageDefault = 20;
export const listCustomerOffersQueryPerPageMax = 100;

export const listCustomerOffersQuerySortDirDefault = `asc`;
export const listCustomerOffersQuerySortKeyDefault = `name`;

export const listCustomerOffersQueryCurrencyCodeMin = 3;
export const listCustomerOffersQueryCurrencyCodeMax = 3;

export const listCustomerOffersQueryCurrencyCodeRegExp = new RegExp("^[A-Z]{3}$");

export const listCustomerOffersQueryLatestOnlyDefault = false;

export const ListCustomerOffersQueryParams = zod.object({
  page: zod.coerce.number().int().min(1).default(listCustomerOffersQueryPageDefault),
  perPage: zod.coerce
    .number()
    .int()
    .min(1)
    .max(listCustomerOffersQueryPerPageMax)
    .default(listCustomerOffersQueryPerPageDefault),
  sortDir: zod.enum(["asc", "desc"]).default(listCustomerOffersQuerySortDirDefault),
  sortKey: zod
    .enum(["name", "offerOrdinal", "version"])
    .default(listCustomerOffersQuerySortKeyDefault),
  expedientId: zod.uuid().optional(),
  offerOrdinal: zod.coerce.number().int().min(1).optional(),
  version: zod.coerce.number().int().min(1).optional(),
  status: zod
    .enum([
      "DRAFT",
      "PENDING",
      "COEFFICIENT_REVIEW",
      "APPROVED",
      "SENT",
      "ACCEPTED",
      "REJECTED",
      "CANCELED",
      "OBSOLETE",
    ])
    .optional(),
  q: zod.coerce
    .string()
    .optional()
    .describe("Literal substring of the canonical displayed Offer name."),
  language: zod.enum(["ES", "EN", "FR"]).optional().describe("Supported business language."),
  currencyCode: zod.coerce
    .string()
    .min(listCustomerOffersQueryCurrencyCodeMin)
    .max(listCustomerOffersQueryCurrencyCodeMax)
    .regex(listCustomerOffersQueryCurrencyCodeRegExp)
    .optional()
    .describe("Canonical Currency code; an unmatched code returns an empty page."),
  statuses: zod
    .array(CustomerOfferStatus)
    .min(1)
    .optional()
    .describe(
      "OR within this selection, AND with other filters including status. Omit for no restriction; empty or unknown entries are invalid. Repeated valid entries are equivalent to one entry.",
    ),
  latestOnly: zod.coerce
    .boolean()
    .default(listCustomerOffersQueryLatestOnlyDefault)
    .describe("Select chain heads before visible filters and pagination."),
});

export const ListCustomerOffersResponse = PaginatedCustomerOfferDto;

/**
 * Every unissued phase, including COEFFICIENT_REVIEW, readiness and unissued OBSOLETE, uses LIVE facts. Issued outcomes and issued OBSOLETE use the sole frozen document with current per-field disclosure. Known costs do not require coefficients; unpriced selling is NOT_PRICED, not zero or restricted. Ordinary read plus protected-price observe controls direct coefficient values, independently of lawful unprotected finance. Older documents use older IDs. Inputs appear once; no raw snapshot. A stored state inconsistent with issued-document presence fails technically; it never substitutes a live or issued representation.
 * @summary Get Offer revision and permitted evaluated document
 */
export const GetCustomerOfferResponse = CustomerOfferDto;

/**
 * Latest DRAFT and ACTIVE dossier only; complete language/currency/content replacement. Currency must have defined JDK minor-unit precision for monetary quotation, even with rich-text-only content. Unsupported precision returns the existing support.domain.money.undefined-precision validation Problem with HTTP 400, without committing the replacement. Shared Currency recognition is unchanged; do not substitute Currency or precision. Check authoritative no-successor ownership in the same decision boundary before assembly or financial acquisition. Retain creator, captured parties, identity and Notes. Introduced/changed supplier selections must be empty and unresolved, or nonempty with complete exact distinct SIMPLE-leaf coverage. Reject nonempty partial coverage; unchanged later source drift remains located issues. Other unresolved DRAFT slots remain allowed. Protected financial changes require permission; opaque text/layout repair grants no repricing. New catalog blocks or changed sold identities/kinds require an actual description in the input language, including with authored null quantity or empty supplier choices; otherwise return sales.customerOffer.invalidSelection with SOURCE_MISSING and unchanged revision. Language changes retain existing inputs but missing localized descriptions withhold affected prices and block positive progression until repaired; no old-language fallback or issued-history rewrite.
 * @summary Replace draft Offer inputs
 */
export const UpdateDraftCustomerOfferBody = UpdateDraftCustomerOfferRequest;

export const UpdateDraftCustomerOfferResponse = zod.void();

/**
 * Latest DRAFT to PENDING content review with ACTIVE parent. Require complete current authored inputs, exact leaf coverage, eligible same-Currency PRICED sources and resolved variables/descriptions and selected Commission. Coefficients and selling calculations are not required or defaulted. Null quantity calculates as one; positive fractions remain valid, zero/negative do not default. MOQ/OQM stay informational. Preserve existing applicable protected-action authority.
 * @summary Submit draft for review
 */
export const SubmitCustomerOfferResponse = zod.void();

/**
 * Latest PENDING to COEFFICIENT_REVIEW with ACTIVE parent and valid current authored inputs, not completed selling pricing. Content approver is authenticated actor. This does not enter readiness or authorize Send. Existing applicable protected-action authority remains; valid source-only price drift does not add another approval stage.
 * @summary Approve content into coefficient review
 */
export const ApproveCustomerOfferResponse = zod.void();

/**
 * Latest PENDING/COEFFICIENT_REVIEW/APPROVED to DRAFT under existing write authority, ACTIVE parent and absent issued document. Clear all coefficient decisions and current review/readiness attribution; retain authored content, flags, captured parties and Notes. No source-validity requirement. Issued facts never become editable.
 * @summary Move never-issued Offer to draft for repair
 */
export const MoveCustomerOfferToDraftResponse = zod.void();

/**
 * Latest APPROVED to SENT under unchanged Send/conditional protected management authority, ACTIVE parent and no prior issuance. Validate fresh complete facts against confirmed commercial content/selling terms and server mutation/stage identity. Changed confirmation returns sales.customerOffer.confirmationStale with HTTP 409 and no issued Event. Hidden internal drift with unchanged confirmed commercial terms uses fresh internal facts. Freeze the same evaluation that was compared, never a recapture or viewer DTO. After snapshot validation, check the captured ECB publication again at the final issuance decision without recapture. A crossed deadline returns sales.customerOffer.exchangeRatesUnavailable with HTTP 409 and no Event, even if a newer publication is now installed. A qualifying publication change absorbed by selling rounding does not alone stale confirmation. Same-currency issuance needs no ECB publication. No automatic email delivery. Reconcile uncertain committed acknowledgement by reads, never blind replay.
 * @summary Record immutable issuance
 */
export const SendCustomerOfferBody = SendCustomerOfferRequest;

export const SendCustomerOfferResponse = zod.void();

/**
 * Latest SENT to ACCEPTED; ACTIVE dossier. Check actual no-successor ownership in the same decision boundary. Use exact issued terms without current Engineering/user reevaluation. Project readiness remains outside scope.
 * @summary Record acceptance of issued terms
 */
export const AcceptCustomerOfferResponse = zod.void();

/**
 * Latest SENT to REJECTED; ACTIVE dossier. Check actual no-successor ownership in the same decision boundary, without source validation or automatic successor. Previous issued document remains immutable.
 * @summary Record customer rejection
 */
export const RejectCustomerOfferResponse = zod.void();

/**
 * Latest SENT to CANCELED; ACTIVE dossier. Check actual no-successor ownership in the same decision boundary, without source validation or canceling the owning Expedient/project.
 * @summary Record customer cancellation
 */
export const CancelCustomerOfferResponse = zod.void();

/**
 * REJECTED source, no successor, ACTIVE dossier and authorization required. New DRAFT identity/version; retain chain/predecessor, copy structural content/language/currency/Notes and every authored input value and flag, regardless of remembering, including null quantities, literal/binding values and complete supplier selections. Preserve stale copied references for repairable current evaluation issues, without pruning or defaulting; protected financial copying still requires authorization. Template opening alone retains remembered clearing and empty new Notes. Capture current eligible parties and new creator. Start with unset content approval/readiness and no coefficient decisions. Recalculate live sources; never copy an issued calculation as current authority. A concurrent event-store append rejection remains a technical HTTP 500, not a deterministic stage-conflict HTTP 409. Reconcile the current revision and chain before another explicit action; never automatically replay an accepted write.
 * @summary Create explicit successor revision
 */
export const CreateCustomerOfferRevisionResponse = zod.uuid();

/**
 * DRAFT and ACTIVE dossier only. Check current authoritative stage before Note identity allocation or input assembly. Historical REJECTED revisions remain read-only; creating a successor does not reopen their Notes.
 * @summary Add draft Offer Note
 */
export const AddCustomerOfferNoteBody = NoteInput;

export const AddCustomerOfferNoteResponse = NoteId;

/**
 * DRAFT and ACTIVE dossier only; preserve Note identity. Check current authoritative stage before owned Note lookup or input assembly. Historical REJECTED revisions remain read-only.
 * @summary Replace draft Offer Note
 */
export const EditCustomerOfferNoteBody = NoteInput;

export const EditCustomerOfferNoteResponse = zod.void();

/**
 * DRAFT and ACTIVE dossier only. Check current authoritative stage before owned Note lookup. Historical REJECTED revisions remain read-only.
 * @summary Remove draft Offer Note
 */
export const RemoveCustomerOfferNoteResponse = zod.void();

/**
 * Requires ordinary Resource read permission, not an existing Resource. Return all supported keys, including currently unresolvable keys, in stable order: $me.email then $technical_director. English labels and descriptions are metadata, not resolved values or availability claims. Creator email uses the Offer creator, never its viewer. No arbitrary subject, expression or user-directory lookup is accepted. Existing evaluation reports unresolved values; literals stay literal and issued text remains frozen independently of discovery.
 * @summary Discover supported editor binding definitions
 */
export const ListCustomerOfferBindingDefinitionsResponseItem = CustomerOfferBindingDefinitionDto;
export const ListCustomerOfferBindingDefinitionsResponse = zod.array(
  ListCustomerOfferBindingDefinitionsResponseItem,
);

/**
 * Requires existing Offer write, ACTIVE parent and authoritative absence of a successor, including retries. Record actual prior stage once; preserve identity/version, content, parties, Notes, review attribution, protected coefficient progress and any frozen document. Repeated OBSOLETE is a guarded no-op and never replaces its origin. Preserve actor/time/from/to audit without a mandatory reason. Unissued obsolete remains LIVE; issued obsolete remains fixed ISSUED. Reconcile committed acknowledgement by reads, not blind replay. A concurrent event-store append rejection remains a technical HTTP 500, not a deterministic stage-conflict HTTP 409. Reconcile the current revision and chain before another explicit action; never automatically replay an accepted write.
 * @summary Mark an Offer obsolete without changing its issued terms
 */
export const ObsoleteCustomerOfferResponse = zod.void();

/**
 * Requires existing Offer write, ACTIVE parent, OBSOLETE and authoritative absence of a successor. Restore server-owned workflow.obsoleteFromStatus on the same identity/version, including private coefficient progress or the same frozen issued outcome. No caller destination, implicit Draft reset or repricing of issued terms. Source validity does not block undo; restored LIVE readiness exposes current repair qualification. Preserve actor/time/from/to audit. HTTP 204 means committed; reconcile current state without assuming DRAFT or replaying an accepted transition.
 * @summary Undo obsolescence to its recorded prior stage
 */
export const RecoverObsoleteCustomerOfferResponse = zod.void();

/**
 * Latest COEFFICIENT_REVIEW and ACTIVE parent only. Require ordinary Offer write plus existing protected-price observe, not an additional manage grant. Address an actual owned Chapter; coefficient must be positive with no maximum-one cap or clamping. No content edit or automatic completion. Saving may retain current source repair issues; read the current backend evaluation after committed acknowledgement.
 * @summary Set an admitted Chapter coefficient
 */
export const SetCustomerOfferCoefficientBody = SetCustomerOfferCoefficientRequest;

export const SetCustomerOfferCoefficientResponse = zod.void();

/**
 * Latest never-issued COEFFICIENT_REVIEW and ACTIVE parent only, with authoritative absence of a successor. Require the same ordinary Offer write, authenticated USER and protected-price observe authority as coefficient setting, including protected Chapters without extra manage. Set both explicit flags atomically for an actual owned Chapter. Preserve coefficients, content approval, identity/version, Notes and all other authored input. No coefficient, complete source pricing or exchange rates are required to save valid intent. Current repair issues remain; technical acquisition or authorization failures do not commit. Every admitted save advances the server mutation stamp, including identical values. No automatic completion, content replacement or replay deduplication. HTTP 204 is committed acknowledgement; reconcile through ordinary reads rather than replaying an accepted write after a failed read.
 * @summary Set Chapter commercial options during pricing review
 */
export const SetCustomerOfferChapterCommercialOptionsBody =
  SetCustomerOfferChapterCommercialOptionsRequest;

export const SetCustomerOfferChapterCommercialOptionsResponse = zod.void();

/**
 * Latest COEFFICIENT_REVIEW to APPROVED readiness with ACTIVE parent, ordinary Offer write and existing protected-price observe. Every Chapter, including optional and zero-cost Chapters, needs an admitted positive coefficient and complete current inputs/pricing. Explicit completion is not another human approval and sends nothing.
 * @summary Complete coefficient review and mark ready
 */
export const CompleteCustomerOfferCoefficientReviewResponse = zod.void();

/**
 * Latest APPROVED to COEFFICIENT_REVIEW under ordinary Offer write and ACTIVE parent. Retain decisions/content/Notes, clear current readiness attribution and retain authored inputs. Only coefficients and the two Chapter commercial flags become editable under coefficient authority; other content and Notes remain read-only. Coefficient values remain protected by existing observe permission.
 * @summary Withdraw readiness for coefficient adjustment
 */
export const ReturnCustomerOfferToCoefficientReviewResponse = zod.void();

/**
 * Latest ACCEPTED/REJECTED/CANCELED to SENT with existing write, ACTIVE-parent and business guards. Race atomically with successor creation. Preserve identity/version and exact issued facts; change outcome only, with actor/time/from/to audit. Do not undo downstream commitments or cancel/restore the owning Expedient. A concurrent event-store append rejection remains a technical HTTP 500, not a deterministic stage-conflict HTTP 409. Reconcile the current revision and chain before another explicit action; never automatically replay an accepted write.
 * @summary Correct latest issued outcome to sent
 */
export const CorrectCustomerOfferOutcomeResponse = zod.void();

/**
 * Read-only business action under unchanged Send authorization. Require latest APPROVED, ACTIVE parent and complete current evaluation. Return commercial terms and an opaque actor/Offer/mutation-stage-bound token; no Event, early freeze, additional approval or hidden monetary digest. This token is confirmation evidence, never a permission grant.
 * @summary Prepare current commercial confirmation for issuance
 */
export const PrepareCustomerOfferSendResponse = PrepareCustomerOfferSendResult;
